import { multiplyLineVectors } from '@lessonup/pin-renderer';
import { Pin, PinComponent } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import {
  connectedToActiveComponent,
  getLineStyleForComponentPair,
  lineBetweenLinkedComponents,
  LineStyle,
  linkedComponents,
} from './LinkedComponentLines.utils';

export interface LinkedComponentsProps {
  pin: Pin;
  pinComponents: PinComponent[];
  active: PinComponent[];
  scale: number;
  mutationInProgress: boolean;
}

export const LinkedComponentLines: React.FC<LinkedComponentsProps> = ({
  pin,
  pinComponents,
  scale,
  active,
  mutationInProgress,
}) => {
  if (active.length !== 1 || mutationInProgress) return null;
  const linked = linkedComponents(pinComponents, pin);
  const activeComponent = active[0];
  const linkedToActive = connectedToActiveComponent(linked, activeComponent.id);
  if (!linkedToActive.length) return null;

  return (
    <LinesOuterSvg>
      {linkedToActive.map((pair) => {
        const line = lineBetweenLinkedComponents(pair);
        const scaledLine = multiplyLineVectors(line, scale);
        const lineStyle = getLineStyleForComponentPair(pair);

        return (
          <SvgDisplayLine
            key={`${pair[0].id}-${pair[1].id}`}
            x1={scaledLine.start.x}
            y1={scaledLine.start.y}
            x2={scaledLine.end.x}
            y2={scaledLine.end.y}
            $lineStyle={lineStyle}
          />
        );
      })}
    </LinesOuterSvg>
  );
};

const LinesOuterSvg = styled.svg`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const SvgDisplayLine = styled.line<{ $lineStyle: LineStyle }>`
  stroke: ${({ $lineStyle }) => $lineStyle.stroke};
  stroke-width: ${({ $lineStyle }) => $lineStyle.strokeWidth};
  stroke-dasharray: ${({ $lineStyle }) => $lineStyle.strokeDasharray || 'none'};
  stroke-linecap: ${({ $lineStyle }) => $lineStyle.strokeLinecap || 'round'};
  stroke-opacity: ${({ $lineStyle }) => $lineStyle.strokeOpacity || 1};
`;
